import { regionSupportedLanguages } from 'hooks/use-set-user-locale/regionLanguages';
import { country } from 'utils/environment';

export const languageSelectorValidForRegion = (() => {
  const region = country?.toUpperCase();
  return !region || regionSupportedLanguages[region]?.size > 1;
})();
